import Vue from "vue";
import moment from "moment";
import { Route } from "vue-router";
import App from "./App.vue";
import Auth from "./Auth.vue";
import router from "./router";
import store from "./store";
import VueScrollTo from "vue-scrollto";

require("@/assets/css/main.css");
require("../public/css/venuzle.css");

window.templateLabels = {};
window.apiBaseUrl = process.env.VUE_APP_API_URL
  ? process.env.VUE_APP_API_URL
  : "http://localhost:8084/";

console.log("API_URL:" + process.env.VUE_APP_API_URL);

window.VueEvent = new Vue();

Vue.config.productionTip = false;
Vue.prototype.$label = function(label: string, defaultText: string) {
  if (Object.prototype.hasOwnProperty.call(window.templateLabels, label)) {
    return window.templateLabels[label];
  }

  if (defaultText) {
    return defaultText;
  }

  return label;
};

Vue.prototype.$partnerEndpoint = function(path: string) {
  const partnerId = localStorage.partnerId;

  if (!partnerId) {
    if (window.location.pathname != "/login") {
      window.location.replace("/login");
    }
    return;
  }

  return "/api/internal/v1/partners/" + partnerId + "/" + path;
};

Vue.prototype.$appConfigs = () => {
  return window.appConfigs;
};

Vue.prototype.$moment = moment;

Vue.use(VueScrollTo);

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);

Vue.directive("click-outside", {
  bind: function(el: any, binding, vnode: any) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target))) {
        event.stopPropagation();
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el: any) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
    el.clickOutsideEvent = null;
  }
});

let baseTemplate: any = null;

new Vue({
  router,
  store,

  data() {
    return {
      authRelatedRoutes: ["Login", "Register"]
    };
  },

  created() {
    this.checkLogin("");

    router.beforeEach((to: Route, from: Route, next: any) => {
      this.checkLogin(to.name || "");
      next();
    });
  },

  render: h => h(baseTemplate),

  methods: {
    checkLogin(routeName: string) {
      const newRouteName = routeName || this.$route.name;

      if (this.isAuthRelatedRoute(newRouteName || "")) {
        baseTemplate = Auth;
      } else {
        baseTemplate = App;
      }

      this.$forceUpdate();
    },

    isAuthRelatedRoute(routeName: string) {
      return this.authRelatedRoutes.indexOf(routeName) !== -1;
    }
  }
}).$mount("#app");
